const assetBasePath = 'https://fb-r2.c1-p8.com/';
// const assetBasePath = './_';

function showLog(message) {
    document.getElementById('visual-log').innerHTML = message;
}

/* global window, document, localStorage */

const DEFAULT_AUDIO_CONFIG = {
    backgroundTrackUrl: assetBasePath + 'audio/background/dramatic_spooky_organ.mp3',
    backgroundVolume: 0.8,
    backgroundPlaybackMode: 'buffer', // 'element' or 'buffer' (iOS-safe mixing)
    masterVolume: 1,
    effectVolume: 1,
    effects: {
        fusion: assetBasePath + 'audio/effect/fusion.mp3',
        zap: assetBasePath + 'audio/effect/zap.mp3',
        panel: assetBasePath + 'audio/effect/panel.mp3',
        leva: assetBasePath + 'audio/effect/leva.mp3',
        video_scienziato: assetBasePath + 'audio/effect/video-scienziato.mp3',
        video_home: assetBasePath + 'audio/effect/video-home.mp3',
        video_storm: assetBasePath + 'audio/effect/video-storm.mp3',
    },
    storageKey: 'frankenstein-burger.audio-muted',
    toggleSelector: '[data-audio-toggle]',
    requireToggleActivation: true,
    // When 'buffer', background is played via WebAudio BufferSource (more reliable mixing on iOS)
};

class AudioManager {
    constructor(config = {}) {
        this.config = { ...DEFAULT_AUDIO_CONFIG, ...config };

        this.isMuted = true;

        this.audioContext = null;
        this.masterGain = null;
        this.background = {
            element: null,
            source: null,
        };
        this.backgroundBuffer = { audioBuffer: null, sourceNode: null };
        this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
          || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        this.effectBuffers = new Map();
        this.activeEffectSources = new Set(); // BufferSource attivi (WebAudio)
        this.activeEffectElements = new Set(); // <audio> fallback attivi
        this.videoElements = new Set();
        this.videoListeners = new Map();
        this.videoSources = new Map();
        this.backgroundHasStarted = false;
        this.hasToggleActivation = false;

        this.toggleButton = null;

        this.init();
    }

    init() {
        this.setupAudioContext();
        // showLog('2.5.6 - Audio mode: ' + (this.config.backgroundPlaybackMode));
        this.onDomReady(() => {
            this.bindToggleButton();
            this.registerExistingVideos();
            this.observeNewVideos();
            this.updateToggleUI();
        });
        this.setupVisibilityUnlock();
    }

    onDomReady(callback) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback, { once: true });
        } else {
            callback();
        }
    }

    readStoredMuteState() {
        try {
            const value = localStorage.getItem(this.config.storageKey);
            if (value === null) {
                return null;
            }
            return value === 'true';
        } catch (error) {
            console.warn('[AudioManager] Unable to read mute state from storage.', error);
            return null;
        }
    }

    storeMuteState() {
        try {
            localStorage.setItem(this.config.storageKey, String(this.isMuted));
        } catch (error) {
            console.warn('[AudioManager] Unable to persist mute state.', error);
        }
    }

    setupAudioContext() {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) {
            console.warn('[AudioManager] Web Audio API is not supported in this browser.');
            return;
        }

        try {
            this.audioContext = new AudioContextClass();
            this.masterGain = this.audioContext.createGain();
            this.masterGain.gain.value = this.isMuted ? 0 : this.config.masterVolume;
            this.masterGain.connect(this.audioContext.destination);
            if (this.audioContext) { this.audioContext.latencyHint = 'interactive'; }
        } catch (error) {
            console.error('[AudioManager] Failed to initialise AudioContext.', error);
            this.audioContext = null;
            this.masterGain = null;
            return;
        }

        this.unlockAudioContextOnInteraction();
        this.wireBackgroundToContext();
        this.videoElements.forEach((video) => this.connectVideoToContext(video));
    }

    setupVisibilityUnlock() {
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                this.resumeContext();
            }
        });
    }

    unlockAudioContextOnInteraction() {
        if (!this.audioContext || this.audioContext.state === 'running') {
            return;
        }

        const unlock = async () => {
            await this.resumeContext();
            this.playSilentBuffer();
            cleanUp();
        };
        const cleanUp = () => {
            events.forEach((eventName) => {
                document.removeEventListener(eventName, unlock, true);
            });
        };
        const events = ['touchstart', 'touchend', 'mousedown', 'pointerdown', 'keydown'];
        events.forEach((eventName) => {
            document.addEventListener(eventName, unlock, { once: true, capture: true, passive: true });
        });
    }

    playSilentBuffer() {
        if (!this.audioContext) {
            return;
        }
        const buffer = this.audioContext.createBuffer(1, 1, this.audioContext.sampleRate);
        const source = this.audioContext.createBufferSource();
        source.buffer = buffer;
        source.connect(this.masterGain);
        try {
            source.start(0);
        } catch (error) {
            // No-op: attempting to start a buffer twice would throw, but we only start once.
        }
    }

    async resumeContext() {
        if (!this.audioContext) {
            return;
        }
        if (this.audioContext.state === 'suspended') {
            try {
                await this.audioContext.resume();
            } catch (error) {
                console.warn('[AudioManager] Unable to resume AudioContext.', error);
            }
        }
    }

    bindToggleButton() {
        this.toggleButton = document.querySelector(this.config.toggleSelector);
        if (!this.toggleButton) {
            console.warn(`[AudioManager] Toggle button (${this.config.toggleSelector}) not found.`);
            return;
        }

        this.toggleButton.addEventListener('click', () => {
            this.toggleMute();
        });
    }

    updateToggleUI() {
        if (!this.toggleButton) {
            return;
        }

        this.toggleButton.setAttribute('aria-pressed', this.isMuted ? 'false' : 'true');
        this.toggleButton.classList.toggle('is-muted', this.isMuted);

        const img = this.toggleButton.querySelector('img[data-audio-icon]');
        if (img) {
            if (this.isMuted) {
                img.src = assetBasePath + 'images/icons/audio-on.png';
                img.alt = 'Audio disattivato';
            } else {
                img.src = assetBasePath + 'images/icons/audio-off.png';
                img.alt = 'Audio attivato';
            }
        }
    }

    toggleMute() {
        this.hasToggleActivation = true;
        this.setMuted(!this.isMuted, { forceBackground: true });
        this.restartBackgroundIfNeeded();
    }

    setMuted(muted, options = {}) {
        if (this.isMuted === muted) {
            if (options.updateUI !== false) {
                this.updateToggleUI();
            }
            return;
        }

        this.isMuted = muted;

        if (this.masterGain && this.audioContext) {
            const value = muted ? 0 : this.config.masterVolume;
            this.masterGain.gain.setValueAtTime(value, this.audioContext.currentTime);
        } else if (this.background.element) {
            this.background.element.volume = muted ? 0 : this.config.backgroundVolume;
        }

        this.applyMuteToBackground();
        this.applyMuteToVideos();
        this.updateToggleUI();
        this.storeMuteState();

        if (!this.isMuted) {
            const forceBackground = options.forceBackground || false;
            this.playBackgroundAudio({ force: forceBackground });
        }
    }

    applyMuteToBackground() {
        if (!this.background.element) {
            return;
        }
        if (!this.masterGain) {
            this.background.element.volume = this.isMuted ? 0 : this.config.backgroundVolume;
        }
        this.background.element.muted = false;
    }

    registerExistingVideos() {
        const videos = document.querySelectorAll('video');
        videos.forEach((video) => this.registerVideo(video));
    }

    observeNewVideos() {
        if (!window.MutationObserver) {
            return;
        }

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (!(node instanceof HTMLElement)) {
                        return;
                    }
                    if (node.tagName === 'VIDEO') {
                        this.registerVideo(node);
                    } else {
                        node.querySelectorAll?.('video').forEach((video) => this.registerVideo(video));
                    }
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
        this.videoObserver = observer;
    }

    registerVideo(video) {
        if (!(video instanceof HTMLMediaElement)) {
            return;
        }
        if (this.videoElements.has(video)) {
            return;
        }

        video.setAttribute('playsinline', 'true');
        video.setAttribute('webkit-playsinline', 'true');

        const initialVolume = video.dataset.audioInitialVolume
            ? parseFloat(video.dataset.audioInitialVolume)
            : video.volume || 1;

        video.dataset.audioInitialVolume = String(initialVolume);
        this.videoElements.add(video);

        const resumeHandler = () => {
            this.resumeContext();
        };

        video.addEventListener('play', resumeHandler);
        video.addEventListener('play', () => { this.restartBackgroundIfNeeded(); });
        this.videoListeners.set(video, resumeHandler);

        this.connectVideoToContext(video);
        this.applyMuteToVideo(video);
    }

    applyMuteToVideos() {
        this.videoElements.forEach((video) => this.applyMuteToVideo(video));
    }

    applyMuteToVideo(video) {
        if (!(video instanceof HTMLMediaElement)) {
            return;
        }

        if (this.isMuted) {
            video.muted = true;
            video.volume = 0;
        } else {
            const initialVolume = parseFloat(video.dataset.audioInitialVolume || '1');
            video.volume = Number.isFinite(initialVolume) ? initialVolume : 1;
            video.muted = false;
            video.removeAttribute('muted');
        }
    }

    wireBackgroundToContext() {
        if (!this.audioContext || !this.masterGain || !this.background.element || this.background.source) {
            return;
        }

        try {
            this.background.source = this.audioContext.createMediaElementSource(this.background.element);
            this.background.source.connect(this.masterGain);
        } catch (error) {
            console.warn('[AudioManager] Unable to connect background audio to AudioContext.', error);
        }
    }

    connectVideoToContext(video) {
        if (!this.audioContext || !this.masterGain || this.videoSources.has(video)) {
            return;
        }
        try {
            const source = this.audioContext.createMediaElementSource(video);
            source.connect(this.masterGain);
            this.videoSources.set(video, source);
        } catch (error) {
            console.warn('[AudioManager] Unable to connect video to AudioContext.', error);
        }
    }

    ensureBackgroundElement() {
        if (this.background.element) {
            return this.background.element;
        }

        const src = this.config.backgroundTrackUrl;
        if (!src) {
            console.warn('[AudioManager] No background track configured.');
            return null;
        }

        const audio = new Audio(src);
        audio.loop = true;
        audio.preload = 'auto';
        audio.crossOrigin = 'anonymous';
        audio.setAttribute('playsinline', 'true');
        audio.setAttribute('webkit-playsinline', 'true');
        audio.volume = this.isMuted ? 0 : this.config.backgroundVolume;

        audio.addEventListener('error', (event) => {
            console.error('[AudioManager] Background audio error.', event);
        });

        this.background.element = audio;
        this.wireBackgroundToContext();

        return audio;
    }

    async ensureBackgroundBuffer() {
        if (!this.audioContext) { return null; }
        if (this.backgroundBuffer.audioBuffer) { return this.backgroundBuffer.audioBuffer; }
        const src = this.config.backgroundTrackUrl;
        if (!src) { return null; }
        try {
            const res = await fetch(src, { cache: 'force-cache' });
            const arr = await res.arrayBuffer();
            const buf = await this.audioContext.decodeAudioData(arr);
            this.backgroundBuffer.audioBuffer = buf;
            return buf;
        } catch (e) {
            console.warn('[AudioManager] Failed to load background buffer, fallback to element.', e);
            return null;
        }
    }

    async playBackgroundBuffer() {
        if (!this.audioContext || !this.masterGain) { return; }
        const buf = await this.ensureBackgroundBuffer();
        if (!buf) { return; }
        try { this.backgroundBuffer.sourceNode && this.backgroundBuffer.sourceNode.stop(0); } catch(_) {}
        const src = this.audioContext.createBufferSource();
        src.buffer = buf;
        src.loop = true;
        const gain = this.audioContext.createGain();
        gain.gain.value = this.isMuted ? 0 : this.config.backgroundVolume;
        src.connect(gain).connect(this.masterGain);
        this.backgroundBuffer.sourceNode = src;
        try {
            await this.resumeContext();
            src.start(0);
            this.backgroundHasStarted = true;
        } catch (e) {
            console.warn('[AudioManager] Unable to start background buffer.', e);
        }
    }

    async playBackgroundAudio(options = {}) {
        const { force = false } = options;
        const wantsBuffer = (this.config.backgroundPlaybackMode === 'buffer')
          || (this.isIOS && this.config.backgroundPlaybackMode !== 'element');
        if (wantsBuffer) {
            await this.playBackgroundBuffer();
            return;
        }
        if (this.config.requireToggleActivation && !this.hasToggleActivation && !force) {
            return;
        }
        const audio = this.ensureBackgroundElement();
        if (!audio) {
            return;
        }

        await this.resumeContext();
        this.applyMuteToBackground();

        try {
            const playPromise = audio.play();
            if (playPromise && typeof playPromise.then === 'function') {
                playPromise
                    .then(() => {
                        this.backgroundHasStarted = true;
                    })
                    .catch((error) => {
                        console.warn('[AudioManager] Background audio play blocked.', error);
                    });
            } else {
                this.backgroundHasStarted = true;
            }
        } catch (error) {
            console.warn('[AudioManager] Unable to start background audio.', error);
        }
    }

    async restartBackgroundIfNeeded() {
        if (this.isMuted) return;
        const wantsBuffer = (this.config.backgroundPlaybackMode === 'buffer')
          || (this.isIOS && this.config.backgroundPlaybackMode !== 'element');
        if (wantsBuffer) {
            return;
        }
        const el = this.background.element;
        if (el && el.paused) {
            try {
                await this.resumeContext();
                await el.play();
            } catch (e) {
                console.warn('[AudioManager] Could not resume background element.', e);
            }
        }
    }

    async getEffectBuffer(effectName) {
        if (!this.audioContext) {
            return null;
        }

        if (this.effectBuffers.has(effectName)) {
            return this.effectBuffers.get(effectName);
        }

        const url = this.config.effects[effectName];
        if (!url) {
            console.warn(`[AudioManager] Effect "${effectName}" not configured.`);
            return null;
        }

        try {
            const response = await fetch(url);
            const arrayBuffer = await response.arrayBuffer();
            const buffer = await this.audioContext.decodeAudioData(arrayBuffer);
            this.effectBuffers.set(effectName, buffer);
            return buffer;
        } catch (error) {
            console.warn(`[AudioManager] Failed to load effect "${effectName}".`, error);
            return null;
        }
    }

    async playEffect(effectName) {
        if (this.isMuted) {
            // Respect mute state even if master gain is set to 0 to avoid unnecessary work.
            return;
        }

        if (this.audioContext && this.masterGain) {
            await this.resumeContext();
            const buffer = await this.getEffectBuffer(effectName);
            if (!buffer) {
                return;
            }

            const source = this.audioContext.createBufferSource();
            source.buffer = buffer;
            source.connect(this.masterGain);

            try {
                // Traccia la sorgente per poterla stoppare
                this.activeEffectSources.add(source);
                source.addEventListener('ended', () => {
                    this.activeEffectSources.delete(source);
                });
                source.start(0);
            } catch (error) {
                console.warn(`[AudioManager] Unable to play effect "${effectName}".`, error);
            }
        } else {
            this.playEffectWithElement(effectName);
        }
    }

    playEffectWithElement(effectName) {
        const url = this.config.effects[effectName];
        console.log('audio active');
        console.log(url);
        if (!url) {
            return;
        }

        const audio = new Audio(url);
        audio.preload = 'auto';
        audio.volume = this.isMuted ? 0 : this.config.effectVolume;
        audio.setAttribute('playsinline', 'true');

        const playPromise = audio.play();
        if (playPromise && typeof playPromise.then === 'function') {
            playPromise.then(() => {
                // Traccia elemento per poterlo fermare
                this.activeEffectElements.add(audio);
                const cleanup = () => {
                    this.activeEffectElements.delete(audio);
                };
                audio.addEventListener('ended', cleanup, { once: true });
                audio.addEventListener('error', cleanup, { once: true });
            }).catch(() => {
                // Ignore errors in fallback mode.
            });
        }
    }

    // Ferma tutti gli effetti sonori in riproduzione (WebAudio e fallback <audio>)
    stopAllEffects() {
        // Ferma BufferSource attivi
        this.activeEffectSources.forEach((source) => {
            try {
                source.stop(0);
            } catch (_) {}
        });
        this.activeEffectSources.clear();

        // Ferma elementi <audio> fallback
        this.activeEffectElements.forEach((audio) => {
            try {
                audio.pause();
                audio.currentTime = 0;
            } catch (_) {}
        });
        this.activeEffectElements.clear();
    }

    mute() {
        this.setMuted(true);
    }

    unmute() {
        this.hasToggleActivation = true;
        this.setMuted(false, { forceBackground: true });
        this.restartBackgroundIfNeeded();
    }
}

(function initialiseAudioManager() {
    if (window.audioManager) {
        return;
    }
    const manager = new AudioManager();
    window.audioManager = manager;
})();
